import angular from 'angular'

/**
 * Directive for styling a native select element.
 *
 * Usage:
 *
 * <select vd-select-input ng-options="..."></select>
 *
 * Options:
 *
 * - inline {Boolean}
 *   Optionally style the select as an inline select appearing simply as a clickable link within the surrounding text
 *   matching font size, style, etc.
 *
 * - case {String}
 *   For use with the `inline` option specify `case: 'sentence'` to uppercase the first letter of the selected value
 *   or placeholder if the inline select is at the start of a sentence.
 *
 * e.g.
 *
 * <h2>Here’s what’s happening <select vd-select-input="{ inline: true }" ng-options="..."></select> in your store.<h2>
 */
export default function VdSelectInput() {
  const SELECT_CONTAINER = 'vd-select-container'
  const INLINE_SELECT_TEMPLATE = `
    <label class="vd-select-inline">
      <span class="vd-select-inline-text"></span>
      <span class="vd-select-inline-chevron">
        <span class="fa fa-chevron-down"></span>
      </span>
    </label>
  `

  return {
    restrict: 'A',
    link(scope, $element, tAttrs) {
      const containerEl = $element
        .wrap(`<div class="${SELECT_CONTAINER}" />`)
        .parent()
      tAttrs.$addClass('vd-select')

      const options = scope.$eval(tAttrs.vdSelectInput)

      if (options && options.inline) {
        containerEl.addClass('vd-select-container--inline')

        const inlineSelectEl = angular.element(INLINE_SELECT_TEMPLATE)
        // Equivalent to $element.before(inlineSelectEl), if we were using jQuery.
        $element[0].parentNode.insertBefore(inlineSelectEl[0], $element[0])

        const inlineTextEl = angular.element(
          containerEl[0].querySelector('.vd-select-inline-text')
        )

        const updateInlineText = () => {
          const selectedElement = angular.element(
            $element[0].querySelector('option:checked')
          )
          const isPlaceholder =
            $element[0].selectedIndex === 0 && selectedElement[0].value === ''

          inlineSelectEl.toggleClass(
            'vd-select-inline--placeholder',
            isPlaceholder
          )

          let text = selectedElement.text()
          if (text.length > 0 && options.case === 'sentence') {
            const firstLetter = text[0]
            text = `${firstLetter.toUpperCase()}${text.slice(1)}`
          }
          inlineTextEl.text(text)
        }

        $element.on('change', updateInlineText)
        scope.$applyAsync(updateInlineText)
      }

      scope.$on('$destroy', () => {
        containerEl.remove()
      })
    },
  }
}
